export const appStatus = (e: any) => ({
  type: 'APP_STATUS_CHANGE',
  payload: e,
});
